export default __webpack_public_path__ + "static/media/invitationsSent.2098f4d7.svg";